export default __webpack_public_path__ + "static/media/trustedshops.a7ebfc60.png";